import React from 'react';

interface TestModuleHeaderProps {
  title?: string;
  onSettingsClick?: () => void;
}

const TestModuleHeader: React.FC<TestModuleHeaderProps> = ({ 
  title = "Module Title",
  onSettingsClick 
}) => {
  return (
    <>
      <h1 className="text-heading-large">
        {title}
      </h1>
      <button 
        className="btn-secondary-ghost"
        onClick={onSettingsClick}
      >
        ⚙️ Settings
      </button>
    </>
  );
};

export default TestModuleHeader;